import { CLIENT_STATUS, CLIENT_STATUS_SUCCESS, CLIENT_STATUS_FAIL} from "./actionType";

const initialState ={
    error:"",
    success:"",
    loader: false,
}

const ClientStatus=(state=initialState,action)=>{
    switch(action.type){
        case  CLIENT_STATUS:
            state = {
                ...state,
                loader: true,
            };
            break;
        case CLIENT_STATUS_SUCCESS:
            state = { ...state, success: action.payload, loader: false };
            break;
        case CLIENT_STATUS_FAIL:
            state = { ...state, error: action.payload, loader: false };
            break;
       
    }
    return state;
    }
export default ClientStatus;
